import { Image, LinkBase, Text } from '@belong/ui';
import clsx from 'clsx';
import css from './sfist-bay-area-banner.module.css';

export function SfistBayAreaBanner() {
  return (
    <LinkBase
      href="https://sfist.com/best-property-managers-san-francisco/"
      target="_blank"
    >
      <div
        className={clsx(
          css.container,
          'border-gray bg-light-gray duration-hover hover:border-dark-gray group mx-auto w-full overflow-hidden rounded  border border-solid transition-all hover:cursor-pointer',
        )}
      >
        <div className="flex flex-col lg:flex-row-reverse">
          <div
            className={clsx(
              css.imageContainer,
              'border-gray duration-hover group-hover:border-dark-gray flex flex-row border-solid transition-all',
            )}
          >
            <Image
              src="/homeowner-lp/sfist-cover-image.jpg"
              alt="SFist 11 Best SF Property Management Companies in 2023 Cover Image"
              className="block object-cover"
            />
          </div>
          <div className="px-sm pb-md pt-lg lg:px-xl container flex flex-col items-start text-left">
            <div className="mb-md">
              <Image
                className={clsx(css.logoImage)}
                src="/logos/sfist-logo-red.png"
                alt="SFist logo"
              />
            </div>
            <Text variant="body" className="text-navy sm:absolute sm:hidden">
              {
                '#1 of 11 Best Property Managers in the San Francisco Bay Area. Belong offers homeowners guaranteed rental payments, maximized rental value, and 24/7 expert\u00a0support.'
              }
            </Text>
            <Text
              variant="h3"
              className="text-navy absolute hidden sm:relative sm:block"
            >
              {
                '#1 of 11 Best Property Managers in the San Francisco Bay Area. Belong offers homeowners guaranteed rental payments, maximized rental value, and 24/7 expert\u00a0support.'
              }
            </Text>
            <Text
              variant="body"
              fontWeight="semibold"
              className={clsx(
                'mt-sm text-navy duration-hover group-hover:text-dark-navy lg:mt-md self-end transition-all',
              )}
            >
              READ MORE
            </Text>
          </div>
        </div>
      </div>
    </LinkBase>
  );
}
